import { digitsOnly, result, stringify } from '../shared';

export const key = 'us_bank_account_number';

export const meta = {
  label: 'US Bank Account Number',
  sensitive: false,
  allowed_contact_types: ['string', 'secret'],
  allowed_form_types: ['Text'],
};

export function validate(value) {
  const raw = stringify(value);
  if (!raw) {
    return result(false, '', 'US bank account number is required');
  }
  if (/[a-z]/i.test(raw)) {
    return result(false, raw, 'US bank account number cannot contain letters');
  }

  const digits = digitsOnly(raw);
  if (!digits) {
    return result(false, '', 'US bank account number is required');
  }
  if (digits.length < 4 || digits.length > 17) {
    return result(
      false,
      digits,
      `US bank account number must be 4 to 17 digits (got ${digits.length})`
    );
  }
  return result(true, digits);
}

export function normalize(value) {
  const res = validate(value);
  return res.valid ? res.value : digitsOnly(value);
}

export function display(value) {
  return digitsOnly(value);
}

export function getInputProps() {
  return {
    mask: '#'.repeat(17),
    maxlength: 17,
    inputmode: 'numeric',
  };
}
